import React, { FC, SVGProps } from 'react';
import { useParams } from 'react-router-dom';
import { useGetPolicyTemplate, useGetRulesData } from '../api';
import CreateFromTemplateForm from './components/CreateFromTemplateForm';
import CreateFromTemplateLoader from './components/CreateFromTemplateLoader';
import { EmptyState, EmptyStateIcons } from '@silverfort/sf-components';

export interface RouteParams {
    templateId: string;
}

const CreateFromTemplate: FC = () => {
    const { templateId } = useParams<RouteParams>();
    const { template, loading: loadingTemplate, error: templateError } = useGetPolicyTemplate(templateId);
    const { rulesData, loading: loadingRulesData, error: rulesDataError } = useGetRulesData();
    const loading = loadingRulesData || loadingTemplate;
    const hasError = !!templateError || !!rulesDataError;

    if (loading) {
        return <CreateFromTemplateLoader />;
    }

    if (hasError) {
        return (
            <div className="rounded-[8px] my-10 mx-10 border border-sf-gray-100 flex flex-col items-center">
                <EmptyState
                    icon={EmptyStateIcons.Error as FC<SVGProps<SVGSVGElement>>}
                    title="Error"
                    contentClassName="whitespace-pre-line"
                    description={`An error occurred loading the selected Policy Template. Try again.\nIf the problem persists, contact your Silverfort representative.`}
                />
            </div>
        );
    }

    if (!rulesData || !template) {
        return null;
    }

    return (
        <CreateFromTemplateForm
            template={template}
            policyConfiguration={rulesData.PolicyConfiguration}
            newPolicyData={rulesData.Rules.find((rule) => rule.id === -1)}
        />
    );
};
export default CreateFromTemplate;
